import React, {
	type PropsWithChildren,
	createContext,
	useContext,
	useEffect,
	useState,
} from 'react';

import {
	CONFLUENCE_CONNECTION_BROKEN,
	CONFTREE_ACCESS_LOADING,
	CONFTREE_CONFLUENCE_ACTIVATING,
	CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND,
	CONFTREE_CONNECT_SPACE,
	CONFTREE_CROSS_SELL,
	CONFTREE_DISPLAY_PAGETREE,
	CONFTREE_ERROR,
	CONFTREE_NO_ACCESS_TEASER,
	CONFTREE_PAGE_NOT_FOUND,
	CONFTREE_PLACEHOLDER,
	CONFTREE_SPACE_NOT_FOUND,
	type ConfluenceLicenseStatusList,
} from '../../state/ui/types';
import { Routes } from './types';

export const confluenceLicenseRoutes: {
	[K in ConfluenceLicenseStatusList]: Routes;
} = {
	[CONFTREE_CROSS_SELL]: Routes.TemplatePreview,
	[CONFTREE_CONFLUENCE_ACTIVATING]: Routes.ConfluenceActivating,
	[CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND]: Routes.ConfluenceActivatingOnDemand,
	[CONFTREE_CONNECT_SPACE]: Routes.ConnectSpace,
	[CONFTREE_ERROR]: Routes.ServerError,
	[CONFTREE_NO_ACCESS_TEASER]: Routes.ServerErrorAccess,
	[CONFTREE_SPACE_NOT_FOUND]: Routes.SpaceOrPageNotFound,
	[CONFTREE_PAGE_NOT_FOUND]: Routes.SpaceOrPageNotFound,
	[CONFLUENCE_CONNECTION_BROKEN]: Routes.SpaceOrPageNotFound,
	[CONFTREE_DISPLAY_PAGETREE]: Routes.ConfluenceTree,
	[CONFTREE_PLACEHOLDER]: Routes.ConfluenceTree,
	[CONFTREE_ACCESS_LOADING]: Routes.ConfluenceTree,
};

interface RouteContextValues {
	navigate: (route: Routes) => void;
	activeRoute?: Routes;
}

const RouteContext = createContext<RouteContextValues>({
	navigate: () => void 0,
});

export const useRouter = () => useContext(RouteContext);

export const RouteProvider = ({
	children,
	confluenceLicenseStatus,
}: PropsWithChildren<{
	confluenceLicenseStatus: ConfluenceLicenseStatusList;
}>) => {
	const [activeRoute, setActiveRoute] = useState<Routes | undefined>();

	useEffect(() => {
		setActiveRoute(confluenceLicenseRoutes[confluenceLicenseStatus]);
	}, [confluenceLicenseStatus]);

	const navigate = (route: Routes) => {
		setActiveRoute(route);
	};

	return (
		<RouteContext.Provider value={{ navigate, activeRoute }}>{children}</RouteContext.Provider>
	);
};
